import React from "react";
import "./ImageGrid.css";
import decryptUrl from "../../util/img-decryption";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { addParamsURL } from "../../util/helper";
import "react-lazy-load-image-component/src/effects/blur.css";
import { Text } from "@jds/core";

// const ImageGrid = ({ images, emptyGrid, setImgOpen }) => {
const ImageGrid = ({
  images,
  emptyGrid,
  setImgOpen,
  setCurrIndex,
  currentIndex,
  selectImg,
  lastElementRef = null,
  param = true,
  viewMore = false,
  totalCount
}) => {
  return (
    <div className="image-grid">
      {images.map((src, index) => {
        const imgSrc = src?.thumbnailFileSignedPath
          ? param
            ? addParamsURL(decryptUrl(src?.thumbnailFileSignedPath), {
              size: "s",
            })
            : decryptUrl(src?.thumbnailFileSignedPath)
          : "";
        console.log(imgSrc);
        return (
          // <div key={index} className="image-cell" onClick={() => {
          //     setImgOpen({ src: src?.reducedFileSignedPath ? addParamsURL(decryptUrl(src?.reducedFileSignedPath), { size: "s" }) : '', index: index + 1 })
          // }}>
          //     {!emptyGrid && <LazyLoadImage src={imgSrc} placeholderSrc={imgSrc} alt={`Image ${index} `} />}
          // </div>
          <div
            key={index}
            className={`image-cell ${selectImg && currentIndex == index ? "selected" : ""
              }`}
            onClick={() => {
              setImgOpen &&
                setImgOpen({
                  src: src?.reducedFileSignedPath
                    ? addParamsURL(decryptUrl(src?.reducedFileSignedPath), {
                      size: "s",
                    })
                    : "",
                  index: index + 1,
                });
              setCurrIndex && setCurrIndex(index);
            }}
            ref={index + 1 == images?.length ? lastElementRef : null}
          >
            {!emptyGrid && (
              <LazyLoadImage
                src={imgSrc}
                placeholderSrc={imgSrc}
                alt={`Image ${index} `}
                style={{
                  pointerEvents: "none",
                  userSelect: "none",
                  "-webkit-touch-callout": "none",
                }}
              />
            )}
          </div>
        );
      })}
      {viewMore &&
        <div className="view-more-overlay">
          <Text text={`+ ${images.length === 0 ? totalCount : totalCount - 10}`} appearance="body-xs" color="white" />
          <Text text="View all in app" appearance="body-xs" color="white" />
        </div>
      }
    </div>
  );
};

export default ImageGrid;
